import { Modal, CircularProgress } from "@mui/material";
import styled from "styled-components";
import { useEffect, useState } from "react";
import Api from "../../libs/api";
import Storage from "../../libs/storage";
import { useNavigate } from "react-router-dom";

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 632px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);

    @media (max-width: 800px) {
        margin-right: 16px;
        width: calc(100% - 32px);
    }
`;

const CustomizedTitle = styled.div`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.96px;
    margin-bottom: 30px;
`;

const Line = styled.div`
  border: none;
  height: 10px;
  border-bottom: 2px solid #57c4c2;
  width: 96px;
`;

const TitleBreak = styled.br`
    display: none;

    @media (max-width: 800px) {
        display: block;
    }
`;

const ModalClose = styled.img`
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
    z-index: 10;
    width: 24px;
    height: 24px;
`;

const ModalContent = styled.div`
    display: flex;
    padding: 40px;
`;

const Content = styled.div`
    flex: 1;
`;

const Text = styled.p`
    color: #181122;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 133%;
    letter-spacing: -0.28px;
    margin-bottom: 24px;
`;

const BoxBlue = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-radius: 8px;
    border: ${props => props.$currentFreePlan ? '1px solid #463794' : '1px solid #E3E3E3'};
    background: ${props => props.$currentFreePlan ? '#463794' : 'transparent'};
    margin-bottom: 8px;
    width: 100%;
    cursor: ${props => props.$currentFreePlan ? 'default' : 'pointer'};

    &:hover {
        border: 1px solid #473694;
    }
`;

const TextBoxBlue = styled.p`
    color: ${props => props.$currentFreePlan ? '#FFF' : '#000'};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const HighlightedTextBoxBlue = styled.p`
    color: ${props => props.$currentFreePlan ? '#FFF' : '#000'};
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
`;

const SubTitleBoxBlue = styled.p`
    color: ${props => props.$currentFreePlan ? '#FFF' : '#999'};
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const BoxPrice = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 8px;
    row-gap: 8px;
    margin: 0px;
    width: 100%;
    margin-bottom: 10px;

    @media (max-width: 800px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const BoxPriceLoading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px;
    width: 100%;
    margin-bottom: 10px;
    height: 208px;
    border-radius: 8px;
    border: 1px solid #E3E3E3;

    @media (max-width: 800px) {
        height: 316px;
    }
`;

const Card = styled.div`
    min-height: 98px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #E3E3E3;
    background: #FFF;
    padding: 8px;
    cursor: pointer;
    &:hover {
        border: 1px solid #473694;
    }
`;

const Title = styled.p`
    color: #000;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const BoxHighlightedText = styled.div`
    display: flex;
    align-items: center;
`;

const HighlightedTextCard = styled.p`
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    margin-top: 16px;
`;

const TextCard = styled.p`
    color: #999;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const CardLink = styled.div`
    position: relative;
    min-height: 98px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #E3E3E3;
    background: #F1F1F1;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
        border: 1px solid #473694;
    }
`;

const TextCardLink = styled.p`
    color: #473694;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
`;

const ButtonLink = styled.img`
    position: absolute;
    right: 8px;
    top: 8px;
`;

const ModalUpdatePlan = ({ showModal, setShowModal, currentFreePlan }) => {
    const api = Api();
    const storage = Storage();
    const navigate = useNavigate();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getPlans = async () => {
            const data = await storage.getItem("data");
            if (!data) return;
            try {
                setLoading(true);
                let response = await api.getAvailablePlans(data.token);
                if (response.data?.availablePlans) {
                    const first5Plans = response.data.availablePlans.slice(1, 6);
                    const formattedPlans = first5Plans.map(plan => ({
                        id: plan.id,
                        name: plan.name,
                        price: plan.price,
                        maxUsers: plan.maxUsers,
                        description: plan.description,
                        hasLink: false,
                    }));

                    formattedPlans.push({
                        id: "custom",
                        name: "+ de 100 usuários",
                        price: "Sob consulta",
                        maxUsers: null,
                        description: "Sob consulta",
                        hasLink: true,
                    });

                    setPlans(formattedPlans);
                }
            } catch (error) {
                console.error("Erro ao buscar planos:", error);
            } finally {
                setLoading(false);
            }
        };

        if (showModal) {
            getPlans();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal]);

    const TextValue = () => {
        if (currentFreePlan) {
            return "Em 01 de janeiro de 2026 o Zag passou a operar com uma nova política de preços. Conheça nossos planos e continue descomplicando os reembolsos corporativas da sua empresa.";
        } else {
            return "Em 01 de janeiro de 2026 o Zag passou a operar com uma nova política de preços. Faça o upgrade ou opte por continuar utilizando o Zag gratuitamente com até 3 usuários.";
        }
    }

    return (
        <Modal
            open={showModal}
            onClose={() => {
                setShowModal(false);
            }}
        >
            <ModalCenter style={{ overflowY: "auto", maxHeight: "95%", padding: 0, border: 0 }}>
                <ModalClose
                    src="/img/modal_close.svg"
                    onClick={() => setShowModal(false)}
                />
                <ModalContent>
                    <Content>
                        {currentFreePlan ? (
                            <CustomizedTitle>Nova política<TitleBreak /> de preços 2026 <Line /></CustomizedTitle>
                        ) :(
                            <CustomizedTitle>Atualize seu plano!</CustomizedTitle>
                        )}
                        <Text>
                            {TextValue()}
                        </Text>
                        <BoxBlue
                            $currentFreePlan={currentFreePlan}
                            onClick={() => {
                                if (!currentFreePlan) {
                                    navigate("/settings?openPlans=true")
                                }
                            }}
                        >
                            <TextBoxBlue $currentFreePlan={currentFreePlan}>Até 3 usuários</TextBoxBlue>
                            <div>
                                <HighlightedTextBoxBlue $currentFreePlan={currentFreePlan}>Gratuito</HighlightedTextBoxBlue>
                                <SubTitleBoxBlue $currentFreePlan={currentFreePlan}>/sem limites de uso</SubTitleBoxBlue>
                            </div>
                        </BoxBlue>
                        {loading ? (
                            <BoxPriceLoading>
                                <CircularProgress size={40} sx={{ '& circle': { stroke: '#463794' } }} />
                            </BoxPriceLoading>
                        ) : (
                            <BoxPrice>
                                {plans?.map((item, index) => {
                                    if (item.hasLink) {
                                        return (
                                            <CardLink key={index} onClick={() => navigate("/settings?openPlans=true")}>
                                                <div>
                                                    <Title>{item.name}</Title>
                                                    <BoxHighlightedText style={{ paddingTop: 4 }}>
                                                        <HighlightedTextCard style={{ fontSize: 18 }}>{item.description}</HighlightedTextCard>
                                                    </BoxHighlightedText>
                                                </div>
                                                <TextCardLink>Acessar todos os planos</TextCardLink>
                                                <ButtonLink src='/img/linkBlackFriday.svg' alt='Ícone link' />
                                            </CardLink>
                                        )
                                    } else {
                                        const priceStr = String(item.price);
                                        const priceInt = priceStr.split('.')[0];
                                        const priceDec = (priceStr.split('.')[1] || '00').padEnd(2, '0');

                                        return (
                                            <Card key={index} onClick={() => {
                                                setShowModal(false);
                                                navigate(`/settings?openPlans=true&planId=${item.id}`);
                                            }}>
                                                <Title>{item.description}</Title>
                                                <BoxHighlightedText>
                                                    <HighlightedTextCard style={{ fontSize: 12, paddingRight: 2 }}>R$</HighlightedTextCard>
                                                    <HighlightedTextCard style={{ fontSize: 24 }}>{priceInt}</HighlightedTextCard>
                                                    <HighlightedTextCard style={{ fontSize: 16 }}>,{priceDec}</HighlightedTextCard>
                                                </BoxHighlightedText>
                                                <TextCard>/por mês</TextCard>
                                            </Card>
                                        )
                                    }
                                })}
                            </BoxPrice>
                        )}
                    </Content>
                </ModalContent>
            </ModalCenter>
        </Modal>
    );
}

export default ModalUpdatePlan;
